import cn from 'classnames';
import { ReactNode } from 'react';
import './styles.scss';
interface PreMatchTrackerTabProps {
	icon: ReactNode;
	onClick: () => void;
	isActive: boolean;
	title: string;
	disabled?: boolean;
}

const PreMatchTrackerTab = ({ icon, onClick, title, isActive, disabled = false }: PreMatchTrackerTabProps) => (
	<button className={cn(`preMatchTrackerTab`, { 'preMatchTrackerTab--active': isActive })} disabled={disabled} onClick={onClick}>
		{icon}
		{title}
		<span className="preMatchTrackerTab__underline" />
	</button>
);

export default PreMatchTrackerTab;
